import { twMerge } from "tailwind-merge"
import type React from "react"

type HeaderWithSubtitleProps = {
  alignment?: "left" | "right"
  subtitle?: React.ReactNode
  title: React.ReactNode
}

const HeaderWithSubtitle = ({
  alignment = "left",
  subtitle,
  title,
}: HeaderWithSubtitleProps) => {
  return (
    <div
      className={twMerge(
        "flex flex-col gap-px",
        alignment === "left" ? "items-start" : "items-end"
      )}
    >
      <div className="text-[13px] leading-none font-medium">{title}</div>
      {subtitle && (
        <div className="text-inherit text-xs opacity-75">{subtitle}</div>
      )}
    </div>
  )
}

export default HeaderWithSubtitle
